import { render, staticRenderFns } from "./ResourceBorrowing.vue?vue&type=template&id=ec7fae04&scoped=true"
import script from "./ResourceBorrowing.vue?vue&type=script&lang=js"
export * from "./ResourceBorrowing.vue?vue&type=script&lang=js"
import style0 from "./ResourceBorrowing.vue?vue&type=style&index=0&id=ec7fae04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7fae04",
  null
  
)

export default component.exports